import { h } from 'preact'
import { useState, useCallback } from 'preact/hooks'
import PropTypes from 'prop-types'

import classNames from 'lib/classNames'
import Turnstile from 'components/Turnstile'

export default function Captcha({
  className,
  onChange,
  submitting,
  onError,
  theme = 'auto',
  size = 'normal',
  ...props
}){
  const [, setIsVerified] = useState(false)

  const handleVerify = useCallback((token) => {
    setIsVerified(true)
    if (onChange) {
      onChange(token)
    }
  }, [onChange])

  const handleError = useCallback((error) => {
    setIsVerified(false)
    if (onChange) {
      onChange('')
    }
    if (onError) {
      onError(error)
    }
  }, [onChange, onError])

  const handleExpire = useCallback(() => {
    setIsVerified(false)
    if (onChange) {
      onChange('')
    }
  }, [onChange])

  const handleTimeout = useCallback(() => {
    setIsVerified(false)
    if (onChange) {
      onChange('')
    }
  }, [onChange])

  return <div
    {...props}
    className={classNames('Captcha', { className })}
  >
    <Turnstile
      onVerify={handleVerify}
      onError={handleError}
      onExpire={handleExpire}
      onTimeout={handleTimeout}
      disabled={submitting}
      theme={theme}
      size={size}
    />
  </div>
}

Captcha.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  submitting: PropTypes.bool,
  onError: PropTypes.func,
  theme: PropTypes.oneOf(['auto', 'light', 'dark']),
  size: PropTypes.oneOf(['normal', 'compact']),
}
